// extracted by mini-css-extract-plugin
module.exports = {"fontSize":"FontSizeSelectControl_fontSize__3UMu6"};